import { Button, ButtonBaseProps, ButtonSize } from '@shared/components/Button';
import { ASK_MARK_ICON } from './AskMark';
import styles from './AskButton.module.css';

export interface AskButtonProps extends Omit<ButtonBaseProps, 'icon' | 'label'> {
  size?: ButtonSize;
  label?: string;
  iconOnly?: boolean;
  // Holds the pressed look while the feature it opens is showing.
  engaged?: boolean;
}

/**
 * The Lighthouse Ask button: the Ask mark on the Green Gradient. For every control that starts an
 * AI feature (Ask, Capture, Summarize, …). In a menu, use `AskMenuMark` on the `Menu.Item` instead.
 */
export function AskButton({ className, iconOnly, engaged, ...props }: AskButtonProps) {
  const askProps = {
    ...props,
    icon: ASK_MARK_ICON,
    className: [styles.askButton, engaged && styles.engaged, className],
  };

  // Primary's props only take `iconOnly` as a literal `true`, so it's branched rather than passed.
  return iconOnly ? (
    <Button variant="primary" iconOnly {...askProps} />
  ) : (
    <Button variant="primary" {...askProps} />
  );
}
